exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".go-back-button{height:90px;font-size:30px;color:#fff;display:flex;align-items:center;background-color:#8f9ba9;justify-content:space-between;cursor:pointer;border-bottom:2px solid #fff;padding:0 20px}.redCard{color:#f32}.blueCard{color:blue}.yellowCard{color:#eac102}.bestPlayer{color:#eac102}.tinyInput{width:45px}", ""]);

